class ModalCollectEmail {
    constructor(params = {}) {
        this._element = this._clone();
        document.body.appendChild(this._element);
    
        this._modalContentType = (params.contentType) ? params.contentType : 'notify';
        this._modalActionType = (params.actionType) ? params.actionType : 'collect';
        
        this._form = this._element.querySelector('.js-form-collect-email');
    
        this._refuseLink = this._element.querySelector('.js-form-collect-email__refuse');
        this._errorBlock = this._form.querySelector('.js-form-collect-email__errors');
        
        this._isChangeEmail = false;
        this._ajaxInProgress = false;
    
        this.open = this.open.bind(this);
        this._initForm = this._initForm.bind(this);
        this._initFormApplication = this._initFormApplication.bind(this);
        this._initRefuse = this._initRefuse.bind(this);
        this._prepareModalsContent = this._prepareModalsContent.bind(this);
        
        this._handleAfterShow = this._handleAfterShow.bind(this);
        this._handleBeforeClose = this._handleBeforeClose.bind(this);
        this._handleAfterClose = this._handleAfterClose.bind(this);
        
        this._handleFormSubmitStarted = this._handleFormSubmitStarted.bind(this);
        this._handleFormSubmit = this._handleFormSubmit.bind(this);
        this._handleApplicationFormSubmit = this._handleApplicationFormSubmit.bind(this);
        this._handleFormSuccess = this._handleFormSuccess.bind(this);
        this._handleFormFail = this._handleFormFail.bind(this);
        this._handleApplicationFormFail = this._handleApplicationFormFail.bind(this);
    
        this._triggerSubmit = this._triggerSubmit.bind(this);
        this._triggerSuccess = this._triggerSuccess.bind(this);
        this._triggerFail = this._triggerFail.bind(this);
        this._triggerClose = this._triggerClose.bind(this);
        this._triggerRefuse = this._triggerRefuse.bind(this);
    
        // Инициализация
        if (this._modalContentType === 'application') {
            this._initFormApplication();
        } else if (this._modalContentType === 'notify') {
            this._initForm();
        } else if (this._modalContentType === 'subscription') {
            this._initForm();
        } else if (this._modalContentType === 'lectureOrder') {
            this._initForm();
        }
        
        if (this._refuseLink) {
            if (this._modalContentType === 'subscription') {
                this._refuseLink.remove ();
            } else if (this._modalContentType === 'lectureOrder') {
                this._refuseLink.remove ();
            } else {
                this._initRefuse();
            }
        }
        this._prepareModalsContent();
    }
    
    _initForm() {
        $(this._form).iFormFormInit();
        $(this._form).on({
            'is:submit.started':    event => this._handleFormSubmitStarted(event),
            'submit':               event => this._handleFormSubmit(event),
            'is:success':           event => this._handleFormSuccess(event),
            'is:fail':              (event, response) => this._handleFormFail(event, response),
        });
    }
    
    // ToDo решить наследованием
    _initFormApplication() {
        const emailField = this._form.querySelector('[name="email"]');
        const submit = this._form.querySelector('[type="submit"]');
    
        $(emailField).iFormElementInit();
    
        submit.addEventListener('click', event => {
            event.preventDefault();
            
            const isValid = $(emailField).iFormElementCheck();
            if (isValid) {
                emailField.disabled = true;
                submit.disabled = true;
                
                $(this._form).trigger('submit');
            }
        });
        
        $(this._form).on({
            'is:submit.started':    event => this._handleFormSubmitStarted(event),
            'submit':               event => this._handleApplicationFormSubmit(event),
            'is:success':           event => this._handleFormSuccess(event),
            'is:fail':              (event, response) => this._handleApplicationFormFail(event, response),
        });
    }
    
    _initRefuse() {
        this._refuseLink.addEventListener('click', event => {
            event.preventDefault();
            this._triggerRefuse();
        });
    }
    
    _clone() {
        const node = document.getElementById('modalCollectEmail').cloneNode(true);
        node.removeAttribute('id');
        return node;
    }
    
    _prepareModalsContent() {
        const titleEls = this._element.querySelectorAll('.js-modal-collect-email__title');
        const headerEls = this._element.querySelectorAll('.js-modal-collect-email__header');
        
        // Тайтлы
        titleEls.forEach(element => {
            let titleHTML = '';
            if (this._modalContentType === 'application') {
                switch(this._modalActionType) {
                    case 'collect':
                        titleHTML = 'Добавьте почту';
                        break;
                    case 'change':
                        titleHTML = 'Измените почту';
                        break;
                }
                
            } else if (this._modalContentType === 'notify') {
                switch(this._modalActionType) {
                    case 'collect':
                        titleHTML = 'Вы вошли в аккаунт';
                        break;
                    case 'change':
                        titleHTML = 'Измените почту';
                        break;
                }
                
            } else if (this._modalContentType === 'subscription') {
                titleHTML = 'Укажите вашу эл.почту';
                
            } else if (this._modalContentType === 'lectureOrder') {
                titleHTML = 'Укажите вашу эл.почту';
            }

            if (titleHTML) {
                element.innerHTML = titleHTML;
            }
        });
        
        // Шапка модалки
        headerEls.forEach(element => {
            let headerHTML = '';
    
            if (this._modalContentType === 'application') {
                switch(this._modalActionType) {
                    case 'collect':
                        headerHTML =
                            `<div class="mod-title mod-title_d-only">Добавьте почту</div>`;
                        break;
                    case 'change':
                        headerHTML =
                            `<div class="mod-title mod-title_d-only">Измените почту</div>`;
                        break;
                }
            } else if (this._modalContentType === 'notify') {
                switch(this._modalActionType) {
                    case 'collect':
                        headerHTML =
                            `<div class="mod-title mod-title_d-only">Вы вошли в аккаунт</div>
                                <p class="mod-p">Теперь вы&nbsp;можете покупать книги по&nbsp;самой низкой цене.</p>`;
                        break;
                    case 'change':
                        headerHTML =
                            `<div class="mod-title mod-title_d-only">Измените почту</div>`;
                        break;
                }
            } else if (this._modalContentType === 'subscription') {
                headerHTML =
                    `<div class="mod-title mod-title_d-only">Укажите вашу эл.почту</div>`;
            } else if (this._modalContentType === 'lectureOrder') {
                headerHTML =
                    `<div class="mod-title mod-title_d-only">Укажите вашу эл.почту</div>`;
            }

            if (headerHTML) {
                element.innerHTML = headerHTML;
            }
        });
        
        // Описание в модалке
        const description = document.createElement('p');
        description.classList.add('mod-p', 'mod-p_collect-text');
    
        let descriptionText = '';
    
        if (this._modalContentType === 'application') {
            descriptionText = 'Укажите адрес вашей эл.&nbsp;почты для входа в приложение «Альпина.Книги».';
            
        } else if (this._modalContentType === 'notify') {
            descriptionText = 'Укажите адрес вашей эл.&nbsp;почты, чтобы получать новости о&nbsp;новинках и&nbsp;промокод на скидки.';
            if (this._modalActionType === 'collect') {
                descriptionText +=
                    ' Мы&nbsp;также начислим вам <span class="bonus-badge ui-tooltip" data-tooltip-type="bonus" data-tooltip-z-index="99999"><span class="bonus-badge__val" data-type="value">300&nbsp;руб.</span></span>,' +
                    ' которые можно использовать для&nbsp;оплаты первого заказа.';
            }
            
        } else if (this._modalContentType === 'subscription') {
            descriptionText = 'На&nbsp;нее мы вышлем вам детальную информацию о&nbsp;заказе.';
            
        } else if (this._modalContentType === 'lectureOrder') {
            descriptionText = 'На&nbsp;нее мы вышлем вам детальную информацию о&nbsp;заказе.';
        }
        
        description.innerHTML = descriptionText;
        this._form.prepend(description);
    }
    
    _handleAfterShow(instance, slide) {
        const $wrapper = slide.$slide.find(".js-modal-content-inner");
        if ($wrapper.length > 0) {
            new SimpleBar($wrapper[0]);
        }
        slide.$slide.find (".fancybox-content").trigger ("is:open");
    
        setTimeout(() => {
            this._isChangeEmail = false;
        }, 100);
    }
    
    _handleBeforeClose() {
        if (this._ajaxInProgress) {
            return false;
        }
    }
    
    _handleAfterClose(instance, current) {
        this._triggerClose();
    }
    
    _handleFormSubmitStarted(event) {
        this._errorBlock.innerHTML = '';
        this._ajaxInProgress = true;
    }
    
    _handleFormSubmit(event) {
        this._triggerSubmit();
    }
    
    _handleApplicationFormSubmit(event) {
        event.preventDefault();
    
        const emailField = this._form.querySelector('[name="email"]');
        const submit = this._form.querySelector('[type="submit"]');
        
        const formData = {
            email: emailField.value
        };
        if (this._modalActionType === 'change') {
            formData.checkAccount = 'N';
        }
        const ajaxData = {
            SendEbookVerifyCode: formData
        };
        $.ajax({
                method: 'POST',
                url: AJAX_URL,
                data: JSON.stringify (ajaxData),
            })
            .done (response => {
                emailField.disabled = false;
                submit.disabled = false;
                if (response[Object.keys(response)[0]].success === true) {
                    $(this._form).trigger('is:success');
                } else
                    $(this._form).trigger('is:fail', [response]);
            })
            .fail ((jqXHR, textStatus, errorThrown) => {
                emailField.disabled = false;
                submit.disabled = false;
                $(this._form).trigger('is:fail');
            })
        
        this._triggerSubmit();
    }
    
    _handleFormSuccess(event) {
        this._ajaxInProgress = false;
        this._triggerSuccess();
    }
    
    _handleFormFail(event, response = {}) {
        this._ajaxInProgress = false;
        
        const message = (response.message) ? response.message : 'Отправка кода не удалась. Попробуйте пожалуйста позже';
    
        // ToDo сделать метод
        const errorHTML = `<div class="ui-alert ui-alert_danger mod-form__errors-item mod-form__errors-item_mt">${message}</div>`;
        this._errorBlock.innerHTML = errorHTML;
    
        this._triggerFail();
    }
    
    // ToDo решить наследованием
    _handleApplicationFormFail(event, response = {}) {
        this._ajaxInProgress = false;
    
        let message = 'Отправка кода не удалась. Попробуйте пожалуйста позже';
        const dataObject = response[Object.keys(response)[0]];
        if (!jQuery.isEmptyObject(dataObject.errors) && dataObject.errors.code) {
            message = dataObject.errors.code;
        }
    
        // ToDo сделать метод
        const errorHTML = `<div class="ui-alert ui-alert_danger mod-form__errors-item mod-form__errors-item_mt">${message}</div>`;
        this._errorBlock.innerHTML = errorHTML;
    
        this._triggerFail();
    }
    
    _triggerSubmit() {
        const thisEvent = new CustomEvent('modal.collect.email.submit', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerClose() {
        const thisEvent = new CustomEvent('modal.collect.email.close', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerRefuse() {
        const thisEvent = new CustomEvent('modal.collect.email.refuse', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerSuccess() {
        const emailField = this._form.querySelector('input[name="email"]');
        let emailValue;
        if (emailField) {
            emailValue = emailField.value.toLowerCase();
        }
        
        const thisEvent = new CustomEvent('modal.collect.email.success', {
            bubbles: true,
            cancelable: true,
            detail: {
                email: emailValue
            }
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerFail() {
        const thisEvent = new CustomEvent('modal.collect.email.fail', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    // ToDo избавиться от этого костыля для повторной отправки
    resend() {
        $(this._form).trigger('submit');
    }
    
    open() {
        this._errorBlock.innerHTML = '';
        // разблокировка формы при открытии модалки. Если нужно сделать снова доступным при изменении почты
        this._form.querySelectorAll('[data-disabled-on-submit="true"]').forEach(element => {
            element.disabled = false;
            element.dataset.disabledOnSubmit = false;
        });
        $(this._element).iModalOpen({
            afterShow: (instance, slide) => this._handleAfterShow(instance, slide),
            beforeClose: () => this._handleBeforeClose(),
            afterClose: (instance, current) => this._handleAfterClose(instance, current)
        });
    }
}

class ModalVerifyCode {
    constructor(params = {}) {
        this._element = this._clone();
        document.body.appendChild(this._element);
        
        this._modalContentType = (params.contentType) ? params.contentType : 'notify';
        this._modalActionType = (params.actionType) ? params.actionType : 'collect';
        
        this._form = this._element.querySelector('.js-form-collect-email-code');
        
        this._emailValue = params.email || '';
        
        this._changeLink = this._element.querySelector('.js-form-collect-email-code__change');
        this._resendBlock = this._element.querySelector('.js-form-collect-email-code__resend');
        this._errorBlock = this._form.querySelector('.js-form-collect-email-code__errors');
        
        this._isResend = false;
        this._isResendInProgress = false;
        this._ajaxInProgress = false;
        this._isChangeEmail = false;
        
        this.setEmailValue = this.setEmailValue.bind(this);
        this.open = this.open.bind(this);
        this._initForm = this._initForm.bind(this);
        this._initFormApplication = this._initFormApplication.bind(this);
        this._showEmailValue = this._showEmailValue.bind(this);
        this._setTimer = this._setTimer.bind(this);
        this._prepareModalsContent = this._prepareModalsContent.bind(this);
        
        this._handleAfterShow = this._handleAfterShow.bind(this);
        this._handleBeforeClose = this._handleBeforeClose.bind(this);
        this._handleAfterClose = this._handleAfterClose.bind(this);
        this._handleResendClick = this._handleResendClick.bind(this);
        
        this._handleFormSubmitStarted = this._handleFormSubmitStarted.bind(this);
        this._handleFormSubmit = this._handleFormSubmit.bind(this);
        this._handleApplicationFormSubmit = this._handleApplicationFormSubmit.bind(this);
        this._handleFormSuccess = this._handleFormSuccess.bind(this);
        this._handleFormFail = this._handleFormFail.bind(this);
        this._handleApplicationFormFail = this._handleApplicationFormFail.bind(this);
        
        this._triggerSubmit = this._triggerSubmit.bind(this);
        this._triggerSuccess = this._triggerSuccess.bind(this);
        this._triggerFail = this._triggerFail.bind(this);
        this._triggerClose = this._triggerClose.bind(this);
        this._triggerChangeClick = this._triggerChangeClick.bind(this);
        this._triggerResendClick = this._triggerResendClick.bind(this);
        
        // Инициализация
        if (this._modalContentType === 'application') {
            this._initFormApplication();
        } else if (this._modalContentType === 'notify') {
            this._initForm();
        } else if (this._modalContentType === 'subscription') {
            this._initForm();
        } else if (this._modalContentType === 'lectureOrder') {
            this._initForm();
        }
        this._initChangeLink();
        this._prepareModalsContent();
    }
    
    _clone() {
        const node = document.getElementById('modalCollectEmailCode').cloneNode(true);
        node.removeAttribute('id');
        return node;
    }
    
    _prepareModalsContent() {}
    
    _initForm() {
        const input = this._form.querySelector('[name="code"]');
        $(input).iFormElementInit();
        $(this._form).iFormFormInit();
        $(this._form).on({
            'is:submit.started':    event => this._handleFormSubmitStarted(event),
            'submit':               event => this._handleFormSubmit(event),
            'is:success':           event => this._handleFormSuccess(event),
            'is:fail':              (event, response) => this._handleFormFail(event, response),
        });
    }
    
    // ToDo решить наследованием
    _initFormApplication() {
        const codeField = this._form.querySelector('[name="code"]');
        const emailField = this._form.querySelector('[name="email"]');
        const submit = this._form.querySelector('[type="submit"]');
        
        codeField.dataset.iFormMask = '999999';
        $(codeField).iFormElementInit();
        
        submit.addEventListener('click', event => {
            event.preventDefault();
            
            const isValid = $(codeField).iFormElementCheck();
            if (isValid) {
                codeField.disabled = true;
                submit.disabled = true;
                
                $(this._form).trigger('submit');
            }
        });
        
        $(this._form).on({
            'is:submit.started':    event => this._handleFormSubmitStarted(event),
            'submit':               event => this._handleApplicationFormSubmit(event),
            'is:success':           event => this._handleFormSuccess(event),
            'is:fail':              (event, response) => this._handleApplicationFormFail(event, response),
        });
    }
    
    _initChangeLink() {
        this._changeLink.addEventListener('click', event => {
            event.preventDefault();
            this._triggerChangeClick();
        });
    }
    
    _showEmailValue() {
        this._form.querySelector('[name="email"]').value = this._emailValue;
        this._form.querySelector('.js-form-collect-email-code__email').innerText = this._emailValue;
    }
    
    _setTimer() {
        let seconds = 60;
        const resendHtml =
            `<p class="mod-p">Мы&nbsp;${(this._isResend) ? 'повторно ' : ''} отправили код подтверждения.</p>
             <div class="mod-p mod-p_gray">
                 Новый код можно получить через <span class="js-form-collect-email-code__timer-output">${globalFunctions.formatSecondsToTime(seconds)}</span>
             </div>`;
        
        this._resendBlock.innerHTML = resendHtml;
        this._errorBlock.innerHTML = '';
        const codeTimer = this._resendBlock.querySelector('.js-form-collect-email-code__timer-output');
        this._timer = setInterval(() => {
            seconds--;
            if (seconds > 0) {
                codeTimer.innerText = globalFunctions.formatSecondsToTime(seconds);
            } else {
                clearInterval(this._timer);
                this._resendBlock.innerHTML = '<p class="mod-p"><a href="javascript:void(0)" class="link-txt _red _t-semibold js-form-collect-email-code__resend-link">Запросить код повторно</a></p>';
                const resendLink = this._resendBlock.querySelector('.js-form-collect-email-code__resend-link');
                resendLink.disabled = false;
                resendLink.addEventListener('click', event => this._handleResendClick(event))
            }
        }, 1000)
    }
    
    _handleAfterShow(instance, slide) {
        const $wrapper = slide.$slide.find(".js-modal-content-inner");
        if ($wrapper.length > 0) {
            new SimpleBar($wrapper[0]);
        }
        slide.$slide.find (".fancybox-content").trigger ("is:open");
        
        setTimeout(() => {
            if (this._isResendInProgress) {
                this._isResendInProgress = false;
            }
            this._isResend = false;
        }, 100)
    }
    
    _handleBeforeClose() {
        if (this._ajaxInProgress) {
            return false;
        }
    }
    
    _handleAfterClose(instance, current) {
        this._triggerClose();
    }
    
    _handleResendClick(event) {
        event.preventDefault();
        if (!event.target.disabled) {
            event.target.disabled = true;
            this._isResendInProgress = true;
            this._isResend = true;
            this._triggerResendClick();
        }
    }
    
    _handleFormSubmitStarted(event) {
        this._errorBlock.innerHTML = '';
        this._ajaxInProgress = true;
    }
    
    _handleApplicationFormSubmit(event) {
        event.preventDefault();
        
        const codeField = this._form.querySelector('[name="code"]');
        const emailField = this._form.querySelector('[name="email"]');
        const submit = this._form.querySelector('[type="submit"]');
        
        const formData = {
            code: codeField.value,
            email: emailField.value
        };
        if (this._modalActionType === 'change') {
            formData.checkAccount = 'N';
        }
        const ajaxData = {
            EbookLogin: formData
        };
        $.ajax({
                method: 'POST',
                url: AJAX_URL,
                data: JSON.stringify (ajaxData),
            })
            .done (response => {
                codeField.disabled = false;
                submit.disabled = false;
                if (response[Object.keys(response)[0]].success === true) {
                    $(this._form).trigger('is:success');
                } else
                    $(this._form).trigger('is:fail', [response]);
            })
            .fail ((jqXHR, textStatus, errorThrown) => {
                codeField.disabled = false;
                submit.disabled = false;
                $(this._form).trigger('is:fail');
            })
        
        this._triggerSubmit();
    }
    
    _handleFormSubmit(event) {
        this._triggerSubmit();
    }
    
    _handleFormSuccess(event) {
        this._ajaxInProgress = false;
        this._triggerSuccess();
    }
    
    _handleFormFail(event, response) {
        this._ajaxInProgress = false;

        // ToDo сделать метод
        const message = (response && 'success' in response && response.success === false) ? ( 'errorMessage' in response ? response.errorMessage : 'Код неверный') : 'Проверка кода не удалась. Попробуйте пожалуйста позже';
        
        const errorHTML = `<div class="ui-alert ui-alert_danger mod-form__errors-item mod-form__errors-item_mt">${message}</div>`;
        this._errorBlock.innerHTML = errorHTML;
        
        this._triggerFail();
    }
    
    // ToDo решить наследованием
    _handleApplicationFormFail(event, response = {}) {
        this._ajaxInProgress = false;
        
        let message = 'Проверка кода не удалась. Попробуйте пожалуйста позже';
        const dataObject = response[Object.keys(response)[0]];
        if (!jQuery.isEmptyObject(dataObject.errors) && dataObject.errors.code) {
            message = dataObject.errors.code;
        }
        
        // ToDo сделать метод
        const errorHTML = `<div class="ui-alert ui-alert_danger mod-form__errors-item mod-form__errors-item_mt">${message}</div>`;
        this._errorBlock.innerHTML = errorHTML;
        
        this._triggerFail();
    }
    
    _triggerSubmit() {
        const thisEvent = new CustomEvent('modal.verify.code.submit', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerClose() {
        const thisEvent = new CustomEvent('modal.verify.code.close', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerSuccess() {
        const thisEvent = new CustomEvent('modal.verify.code.success', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerFail() {
        const thisEvent = new CustomEvent('modal.verify.code.fail', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerChangeClick() {
        const thisEvent = new CustomEvent('modal.verify.code.change.click', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    _triggerResendClick() {
        const thisEvent = new CustomEvent('modal.verify.code.resend.click', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    setEmailValue(value) {
        this._emailValue = value;
        this._showEmailValue();
    }
    
    open() {
        this._setTimer();
        
        $(this._element).iModalOpen({
            afterShow: (instance, slide) => this._handleAfterShow(instance, slide),
            beforeClose: () => this._handleBeforeClose(),
            afterClose: (instance, current) => this._handleAfterClose(instance, current)
        });
    }
}

class ModalVerifyCodeResult {
    constructor(params = {}) {
        this._element = this._clone();
        document.body.appendChild(this._element);
        
        this._modalContentType = (params.contentType) ? params.contentType : 'notify';
        this._modalActionType = (params.actionType) ? params.actionType :'collect';
        
        this.open = this.open.bind(this);
        this._prepareModalsContent = this._prepareModalsContent.bind(this);
        
        this._handleAfterShow = this._handleAfterShow.bind(this);
        this._handleBeforeClose = this._handleBeforeClose.bind(this);
        this._handleAfterClose = this._handleAfterClose.bind(this);
        
        this._triggerClose = this._triggerClose.bind(this);
        
        this._status = 'success';
        
        // Инициализация
        this._prepareModalsContent();
    }
    
    _clone() {
        const node = document.getElementById('modalCollectEmailResult').cloneNode(true);
        node.removeAttribute('id');
        return node;
    }
    
    _prepareModalsContent() {
        const titles = this._element.querySelectorAll('.js-modal-collect-email-result__title');
        const main = this._element.querySelector('.js-modal-collect-email-result__main');
        const header = this._element.querySelector('.js-modal-collect-email-result__header');
        
        let titleValue = '';
        let mainValue = '';
        
        if (this._status === 'refuse') {
            titleValue = `Подтвердите эл.&nbsp;почту`;
            if (this._modalActionType === 'collect') {
                mainValue = `<p class="mod-p">Вы&nbsp;всегда можете указать почту в&nbsp;личном кабинете и&nbsp;получить за&nbsp;это&nbsp;<span class="bonus-badge ui-tooltip" data-tooltip-type="bonus" data-tooltip-z-index="99999"><span class="bonus-badge__val" data-type="value">300&nbsp;руб.</span></span> бонусов.</p>`;
            }
            if (header) {
                header.classList.remove('mod-header_success');
            }
        } else if (this._status === 'success') {
            if (this._modalContentType === 'application') {
                titleValue = 'Вы&nbsp;подтвердили почту';
                if (this._modalActionType === 'collect') {
                    mainValue = `
                        <p class="mod-p">
                            Страница обновится в&nbsp;течение 3 секунд.
                        </p>`;
                }
            } else if (this._modalContentType === 'notify') {
                titleValue = 'Вы&nbsp;подтвердили почту';
                if (this._modalActionType === 'collect') {
                    mainValue = `
                        <p class="mod-p">
                            А&nbsp;мы&nbsp;начислили вам <span class="bonus-badge ui-tooltip" data-tooltip-type="bonus" data-tooltip-z-index="99999"><span class="bonus-badge__val" data-type="value">300&nbsp;руб.</span></span>,
                            как и обещали. Эти&nbsp;бонусы сгорят через 7&nbsp;дней, спешите их&nbsp;потратить!
                        </p>`;
                }
            }
            if (header) {
                header.classList.add('mod-header_success');
            }
        }
        
        if (titles) {
            titles.forEach(element => {
                element.innerHTML = titleValue;
            })
        }
        if (main) {
            main.innerHTML = mainValue;
        }
    }
    
    _handleAfterShow(instance, slide) {
        const $wrapper = slide.$slide.find(".js-modal-content-inner");
        if ($wrapper.length > 0) {
            new SimpleBar($wrapper[0]);
        }
        slide.$slide.find (".fancybox-content").trigger ("is:open");
    }
    
    _handleBeforeClose() {}
    
    _handleAfterClose(instance, current) {
        this._triggerClose();
    }
    
    _triggerClose() {
        const thisEvent = new CustomEvent('modal.collect.email.close', {
            bubbles: true,
            cancelable: true,
        });
        this._element.dispatchEvent(thisEvent);
    }
    
    open(status = 'success') {
        this._status = status;
        this._prepareModalsContent();
        $(this._element).iModalOpen({
            afterShow: (instance, slide) => this._handleAfterShow(instance, slide),
            afterClose: (instance, current) => this._handleAfterClose(instance, current)
        });
    }
}

class CollectEmail {
    constructor(params = {}) {
        
        this._modalEmail = new ModalCollectEmail({contentType: params.contentType, actionType: params.actionType});
        this._modalCode = new ModalVerifyCode({contentType: params.contentType, actionType: params.actionType});
        this._modalResult = new ModalVerifyCodeResult({contentType: params.contentType, actionType: params.actionType});
        
        this._handleRefuseResponse = this._handleRefuseResponse.bind(this);
        this._triggerRefuse = this._triggerRefuse.bind(this);
        this._triggerSuccess = this._triggerSuccess.bind(this);
        this.show = this.show.bind(this);
        this.showRefuse = this.showRefuse.bind(this);
        this.sendRefuseRequest = this.sendRefuseRequest.bind(this);
        
        this._contentType = params.contentType;
        this._actionType = params.actionType;
        this._onSuccessCallback = params.onSuccess;
        this._onRefuseCallback = params.onRefuse;
        
        this._preventResultShow = false;
        
        
        // Модалка запроса почты
        
        // отправка событий интерфейса модалки - только для неавторизованных
        $(this._modalEmail._element).on({
            'is:success': event => {
                if (!('userLogged' in window.user && window.user.userLogged)) {
                    const analyticsEvent = new CustomEvent('ab.analytics.event', {
                        bubbles: true,
                        cancelable: true,
                        detail: {
                            eventCode: 'authSendValidEmail',
                        }
                    });
                    event.target.dispatchEvent(analyticsEvent);
                }
            },
        });
        
        this._modalEmail._element.addEventListener('modal.collect.email.close', event => {
    
            if (!this._preventResultShow) {
                if (this._contentType === 'subscription') {
                    this._onRefuseCallback();
                } else if (this._contentType === 'lectureOrder') {
                    this._onRefuseCallback();
                } else if (this._actionType === 'collect' && this._contentType !== 'application' && this._contentType !== 'subscription') {
                    this.showRefuse();
                }
            }
            this._preventResultShow = false;
        });
        this._modalEmail._element.addEventListener('modal.collect.email.success', event => {
            this._preventResultShow = true;
            
            setTimeout(() => {
                this._modalCode.setEmailValue(event.detail.email);
                this._modalCode.open();
            }, 150);
        });
        this._modalEmail._element.addEventListener('modal.collect.email.refuse', event => {
            this._preventResultShow = true;
            this.sendRefuseRequest();
            setTimeout(() => {
                this.showRefuse();
            }, 150);
        });
    
        
        // Модалка подтверждения кода
        
        this._modalCode._element.addEventListener('modal.verify.code.close', event => {
            if (!this._preventResultShow) {
                if (this._contentType === 'subscription') {
                    this._onRefuseCallback();
                } else if (this._contentType === 'lectureOrder') {
                    this._onRefuseCallback();
                } else if (this._actionType === 'collect' && this._contentType !== 'application' && this._contentType !== 'subscription') {
                    this.showRefuse();
                }
            }
            this._preventResultShow = false;
        });
        this._modalCode._element.addEventListener('modal.verify.code.success', event => {
            this._preventResultShow = true;
            
            setTimeout(() => {
                if (this._contentType !== 'subscription') {
                    this._modalResult.open('success');   
                }
                this._onSuccessCallback();
            }, 150);
        });
        this._modalCode._element.addEventListener('modal.verify.code.change.click', event => {
            this._preventResultShow = true;
            
            setTimeout(() => {
                this._modalEmail.open();
            }, 150);
        });
        this._modalCode._element.addEventListener('modal.verify.code.resend.click', event => {
            this._preventResultShow = true;
            
            setTimeout(() => {
                this._modalEmail.resend();
            }, 150);
        });
    }
    
    _handleRefuseResponse(response) {}
    
    _triggerRefuse() {
        const thisEvent = new CustomEvent('ab.collect.email.refuse', {
            bubbles: true,
            cancelable: true,
        });
        document.dispatchEvent(thisEvent);
    }
    
    _triggerSuccess() {
        const thisEvent = new CustomEvent('ab.collect.email.success', {
            bubbles: true,
            cancelable: true,
        });
        document.dispatchEvent(thisEvent);
    }
    
    show() {
        this._modalEmail.open();
    }
    
    showRefuse() {
        this._modalResult.open('refuse');
        this._onRefuseCallback();
    }
    
    sendRefuseRequest() {
        this._handleRefuseResponse();
        BX.ajax.runAction('alpina:core.api.user.setCancelEmailPopup', {
            data: {
                userId: window.user.userId,
            }
        }).then(
            response => this._handleRefuseResponse(response),
            response => this._handleRefuseResponse(response)
        );
    }
}

window.ABEmailCollector = {
    defaultNotifyCollector: {
        instance: undefined,
        init: function() {
            if (!window.ABEmailCollector.defaultNotifyCollector.instance) {
                window.ABEmailCollector.defaultNotifyCollector.instance = new CollectEmail({
                    contentType: 'notify',
                    actionType: 'collect',
                    onSuccess: () => {
                        setTimeout(function() {
                            location.reload();
                        }, 3000);
                    },
                    onRefuse: () => {
                        // здесь при отказе ничего не делать
                    }
                });
            }
        },
    },
    defaultApplicationCollector: {
        instance: undefined,
        init: function() {
            if (!window.ABEmailCollector.defaultApplicationCollector.instance) {
                window.ABEmailCollector.defaultApplicationCollector.instance = new CollectEmail({
                    contentType: 'application',
                    actionType: 'collect',
                    onSuccess: () => {
                        setTimeout(function() {
                            location.reload();
                        }, 3000);
                    },
                    onRefuse: () => {
                        // здесь при отказе ничего не делать
                    }
                });
            }
        },
    },
};

document.addEventListener('DOMContentLoaded', function() {
    
    /*
        Класс .js-ab-email-collector-notify-action – при нажатии открывается модалка для сбора почты для уведомлений
        Атрибут data-email-collector-action – название экшна в switch ниже по коду. По умолч., = 'show'
     */
    document.body.addEventListener('click', event => {
        const isTargetFits = event.target.classList.contains('js-ab-email-collector-notify-action');
        const parent = event.target.closest('.js-ab-email-collector-notify-action');
        
        if (isTargetFits || parent) {
            event.preventDefault();
            
            const element = (isTargetFits) ? event.target : parent;
            const action = element.dataset.emailCollectorAction || 'show';
            switch (action) {
                case 'show':
                    window.ABEmailCollector.defaultNotifyCollector.init();
                    window.ABEmailCollector.defaultNotifyCollector.instance.show();
                    break;
            }
        }
    })
    
    /*
        Класс .js-ab-email-collector-action – при нажатии открывается модалка для сбора почты в приложение "Альпина.Книги"
        Атрибут data-email-collector-action – название экшна в switch ниже по коду. По умолч., = 'show'
     */
    document.body.addEventListener('click', event => {
        const isTargetFits = event.target.classList.contains('js-ab-email-collector-action');
        const parent = event.target.closest('.js-ab-email-collector-action');
        
        if (isTargetFits || parent) {
            event.preventDefault();
            
            const element = (isTargetFits) ? event.target : parent;
            const action = element.dataset.emailCollectorAction || 'show';
            switch (action) {
                case 'show':
                    window.ABEmailCollector.defaultApplicationCollector.init();
                    window.ABEmailCollector.defaultApplicationCollector.instance.show();
                    break;
            }
        }
    }) 
});
